import axios from "axios";
import { apiServicesUrl } from "./baseUrl";
import { userAccessToken } from "../helpers";

export const sendReviewRequest = (param) => {
  return axios.post(`${apiServicesUrl}/review_request`, param, {
    headers: {
      "Content-Type": "application/json",
      accept: "application/json",
      Authorization: `Bearer ${userAccessToken()}`,
    },
  });
};

export const getReviewRequests = (param) => {
  const { page, per_page, search_term, practice_id } = param;
  const searchParam = search_term ? `&search_term=${search_term}` : "";
  const practiceParam = practice_id ? `&practice_id=${practice_id}` : "";

  return axios.get(
    `${apiServicesUrl}/review_request?page=${page}&per_page=${per_page}${searchParam}${practiceParam}`,
    {
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: `Bearer ${userAccessToken()}`,
      },
    }
  );
};
